import __vue_component__$1 from '../HseIcon/HseIcon.vue.js';
import __vue_component__ from '../HseBadge/HseBadgeLabel.vue.js';
import { __extends, __assign, __decorate, __metadata } from 'tslib';
import { InjectReactive, Prop, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import 'reflect-metadata';
import { SidebarVariant, SidebarItemSize, SidebarContextKey } from './types.js';

/**
 * Пункт меню сайдбара
 */
var HseSidebarItem = /** @class */ (function (_super) {
    __extends(HseSidebarItem, _super);
    function HseSidebarItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HseSidebarItem.prototype, "hasIcon", {
        get: function () {
            return !!this.icon;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSidebarItem.prototype, "hasLabel", {
        get: function () {
            return !!this.label || this.$slots.label;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSidebarItem.prototype, "showIconBadge", {
        get: function () {
            return (this.sidebarContext &&
                !this.sidebarContext.open &&
                this.sidebarContext.variant === SidebarVariant.dynamic &&
                this.hasLabel);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSidebarItem.prototype, "additionalProps", {
        get: function () {
            var props = __assign({}, this.$attrs);
            if (this.component === 'button')
                props.type = 'button';
            return props;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSidebarItem.prototype, "computedSize", {
        get: function () {
            var _a, _b, _c;
            return (_c = (_a = this.size) !== null && _a !== void 0 ? _a : (_b = this.sidebarContext) === null || _b === void 0 ? void 0 : _b.size) !== null && _c !== void 0 ? _c : SidebarItemSize.wide;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        InjectReactive({
            from: SidebarContextKey,
            default: undefined
        }),
        __metadata("design:type", Object)
    ], HseSidebarItem.prototype, "sidebarContext", void 0);
    __decorate([
        Prop({
            default: 'button'
        }),
        __metadata("design:type", Object)
    ], HseSidebarItem.prototype, "component", void 0);
    __decorate([
        Prop(EnumProp(undefined, SidebarItemSize)),
        __metadata("design:type", String)
    ], HseSidebarItem.prototype, "size", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSidebarItem.prototype, "selected", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", Object)
    ], HseSidebarItem.prototype, "icon", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", Object)
    ], HseSidebarItem.prototype, "label", void 0);
    __decorate([
        Prop({
            default: function () { return ({}); }
        }),
        __metadata("design:type", Object)
    ], HseSidebarItem.prototype, "classes", void 0);
    HseSidebarItem = __decorate([
        Component({
            name: 'HseSidebarItem',
            components: {
                HseBadgeLabel: __vue_component__,
                HseIcon: __vue_component__$1
            }
        })
    ], HseSidebarItem);
    return HseSidebarItem;
}(Vue));

export default HseSidebarItem;
